export const MODULE_PREFIX = "pvs-activities";
export const MODULE_FOLDER = "pvs_activities";
export const SURVEY_MODULE_PREFIX = "survey-activities";
export const SURVEY_MODULE_FOLDER = "survey_activities";

export const HEADING_SIZE_DEFAULT = "h4";
export const HEADING_FONT_DEFAULT = "SohneSchmal-Kraftig";
export const HEADING_WEIGHT_DEFAULT = "normal";
export const CONTENT_ALIGNMENT_DEFAULT = "left";

export const DATA_ELEMENT_BASIC_TYPES = {
    0: {
        label: "Structure Elements",
        children: {
            static_text: "Static Text",
            heading: "Heading",
            group: "Group",
            horizontal_line: "Horizontal Line",
            read_only_variable: "Read-Only Variable",
            // calculated: 'Calculated',
        },
    },
    1: {
        label: "Basic Elements",
        children: {
            text: "Text",
            number: "Number",
            email: "Email",
            telephone: "Telephone",
            date: "Date",
            description: "Description",
            attachment: "Attachment",
            percentage: "Percentage",
            affirmation: "Affirmation (Yes/No)",
            radio_selection: "Radio Selection",
            date_finalisation: "Date Finalisation",
            list: "List",
            // list_last_5_years: 'List: Last 5 Years',
            // list_last_30_years: 'List: Last 30 Years',
            // list_last_50_years: 'List: Last 50 Years',
        },
    },
};

export const DATA_ELEMENT_TYPES = {
    ...DATA_ELEMENT_BASIC_TYPES,
    2: {
        label: "Advance Elements",
        children: {
            form_table: "Form Table",
            dform_button: "DForm Button",
        },
    },
    3: {
        label: "Custom Elements",
        children: {
            //   mission_info: "Mission Information",
            experts: "Experts Selection",
            peer_reviewer_selection: "Peer Reviewer Selection",
            expert_action: "Expert Action",
            peer_reviewer_action: "Peer Reviewer Action",
            experts_cc_table: "Experts CC Table",
            survey_form: "PVS Survey Self Assessment",
            survey_action_taken: "PVS Survey Actions Taken Per CC"
        },
    },
    // list_table: 'List Table',
    // neg_erc_components: 'NEG/ERC Components',
    // custom_form_table: 'Custom Form Table',
    // custom_component: 'Custom Component',
};

export const REPORT_DATA_ELEMENT_TYPES = {
    ...DATA_ELEMENT_TYPES,
    4: {
        label: "Report Elements",
        children: {
            dynamic_cc_table: "Dynamic CC Table",
            cc_summary_table: "CC Summary Table",
        },
    },
};

export const VARIABLE_ALLOWED_DATA_ELEMENTS = [
    "text",
    "number",
    "email",
    "telephone",
    "date",
    "description",
    "percentage",
    "affirmation",
    "radio_selection",
    "list",
    "form_table",
];

export const HEADING_SIZE_OPTIONS = {
    h1: "Heading 1",
    h2: "Heading 2",
    h3: "Heading 3",
    h4: "Heading 4",
    h5: "Heading 5",
    h6: "Heading 6",
    normal: "Normal text",
};

export const HEADING_WEIGHT_OPTIONS = {
    lighter: "Lighter",
    normal: "Normal",
    bold: "Bold",
    bolder: "Bolder",
};

export const BOTTOM_SPACING_OPTIONS = {
    More: "mb-3",
    Normal: "mb-2",
    Less: "mb-1",
};
export const BOTTOM_SPACING_DEFAULT = BOTTOM_SPACING_OPTIONS.Normal;

export const HEADING_FONT_OPTIONS = {
    "Sohne-Buch": "Sohne Buch (Preferred for normal text)",
    "SohneSchmal-Kraftig": "Sohne Schmal Kraftig (Preferred for Headings)",
};

export const CONTENT_ALIGNMENT_OPTIONS = {
    left: "Left",
    center: "Center",
    right: "Right",
    justify: "Justify",
};

export const ALPHABETS_ARRAY = "abcdefghijklmnopqrstuvwxyz".split("");
export const AU_LEVEL_1_TEXT = "Provinces, States, Governorate etc.";
export const AU_LEVEL_2_TEXT = "District, Metropolitan Area etc.";
export const RADIO_SELECTION_VALUES = [
    { id: "text", value: "Text" },
    { id: "attachment", value: "Attachment" },
];
export const ELEMENT_GROUP_COLUMN_SIZES_MAPPINGS = {
    100: "12",
    75: "9",
    50: "6",
    33.33: "4",
    25: "3",
};
export const ELEMENT_GROUP_COLUMN_SIZES = ["100", "75", "50", "33.33", "25"];

export const FUNDING_SOURCE = {
    self_funding: "FS_SF",
    request_woah: "FS_RWLF",
};

export const MISSION_EXPERT_RESPONSE_STATUSES = {
    0: "Pending",
    1: "Accepted",
    2: "Rejected",
    3: "Leave"
};

export const newElementForm = {
    data_type: "",
    label: "",
    list_id: "",
    list_appearance: "dropdown",
    list_table_list_id: "",
    list_table_column_name: "",
    custom_form_table: "",
    formula: "",
    has_comments: 0,
    number: "",
    number_suffix: "",
    show_number: "",
    description: "",
};

export const MISSION_STATUS = {
    INACTIVE: "0",
    ACTIVE: "1",
    COMPLETE: "2",
    REQUEST: "3",
};

export const MISSION_STATUS_LIST = {
    "completed": 263,
    "in_planning": 264,
    "ongoing": 265,
    "on_hold": 266,
    "uncertain": 267,
    "cancelled": 268,
    "pre_mission": 414,
    "preparatory_phase": 415,
    "implementation_phase": 416,
    "post_mission_phase": 417,
    "report_phase": 418,
};

export const FORM_RULE_ACTION_TYPES = {
    assign_form: "Assign Template",
    generate_notification: "Generate Notification",
    send_email: "Send Email",
    process_peer_reviewer_decision: "Process Peer Reviewer Decision",
    process_expert_decision: "Process Expert Decision",
    process_mission_specific_content: "Process Mission Specific Content",
    mission_start_end_date_submission: "Mission Start and End Date Submission",
};

export const FORM_RULE_ACTION_USER_TYPES = {
    mission_manager: "Mission Manager",
    delegates: "Delegates (Mission Country)",
    experts: "Experts (Current Mission)",
    specific_person: "Specific Person",
};

export const FORM_RULE_ACTION_CUSTOM_ROLES = {
    template_assigned_user: "Assigned User (Currently Template Assigned)",
    mission_manager: "Mission Manager (Current Mission)",
    current_experts: "All Experts (Current Mission)",
    delegates: "Delegates (Mission Country)",
    delegate_proxy: "Delegate Proxy (Mission Country)",
    mission_contact_person: "Mission Contact Person (Mission Country)",
};

export const defaultSingleCCDataTemplate = {
    content: "",
    loa_score_id: "",
    key_value_id: "",
    key_value_text: "",
    document_id: null,
};

export const initialCommentFormFields = {
    type: "comment",
    content: "",
    is_resolved: false,
    replies: [],
};


export const Mission_Document_Category = {
    past_report_document: 326,
    expert_toolbox: 327,
    correspondence_document: 328,
};
export const Mission_Document_Sub_Category = {
    past_report_document: 330,
    expert_toolbox: 331,
    correspondence_document: 332,
};
export const Mission_Document_type = {
    report: 1,
    baseline_document: 46,
    correspondence_document: 462,
    other_document: 513,
    expert_toolbox: 461,
};

export const BUILDER_ELEMENT_DEPENDENCY_OPERATIONS = {
    eq: "Equal To",
    lt: "Less Than",
    lt_eq: "Less Than / Equal To",
    gt: "Greater Than",
    gt_eq: "Greater Than / Equal To",
};

export const PROCESSES_PARALLEL_PROCESS = {
    0: "No",
    1: "Yes - WOAH Process",
    2: "Yes - Experts Process",
    3: "Yes - Delegate Process",
};

export const MOVEMENTS_STATUS = {
    pending: 1,
    completed: 2,
    cancel: 3,
    valditation: 4,
    approval: 5,
    decision: 6,
    skip: 7,
};
export const tasks_status = {
    pending: 0,
    completed: 1,
    all: 2,
};

export const MissionCorrespondenceUsersList = [3, 4, 5];

export const DFORM_ASSIGNED_FOR = {
    drafting: 334,
    validation: 335,
    approval: 336,
    decision: 337
};

export const EXPERTS_POSITIONS = {
    team_leader: 87,
    team_member: 88,
    observer: 93,
    peer_reviewer: 94,
    trainee_expert: 95,
};

export const FORM_TYPES = {
    form: 'FT_FRM',
    report: 'FT_RPT',
    letter: 'FT_LTR',
    email: 'FT_EML',
};

export const DATE_FIELD_VIEWS = [
    { label: 'Date, Month & Year', value: 'DMY' },
    { label: 'Month & Year', value: 'MY' },
];
export const START_DATE = [
    { label: 'Today', value: 'today' },
    { label: 'Custom', value: 'custom' },
    { label: 'Variable', value: 'variable' },
];

export const FIELD_IS_REQUIRED_OPTIONS = [
    { label: 'No', value: '0' },
    { label: 'Yes', value: '1' },
];

export const FIELD_SHOW_HISTORY_BUTTON_OPTIONS = [
    { label: 'No', value: '0' },
    { label: 'Yes', value: '1' },
];

export const REPORT_ASSIGNMENT_STATUS = {
    IN_DRAFT: 474,
    DRAFTED: 475,
    IN_PEER_REVIEW: 476,
    PEER_REVIEWED_EVALUATION: 477,
    UNDER_WOAH_REVIEW: 478,
    PRELIMINARY_REPORT: 479,
    UNDER_DELEGATE_REVIEW: 480,
    COMMENT_RESOLUTION: 481,
    COMPLETED: 482,
};

export const FIELD_LIST_ALIGNMENT_MODE_OPTIONS = [
    { label: 'Horizontal', value: 'h' },
    { label: 'Vertical', value: 'v' },
];

export const RULE_CONDITION_TYPES = {
    basic: [
        { label: 'Variable', value: 'variable' },
    ],
    form: [
        { label: 'Expert/Peer Reviewer Decision', value: 'expert_decision' },
        { label: 'Form Attachment', value: 'form_attachment' },
    ],
    letter: [
        { label: 'Letter Status', value: 'letter_status' },
    ]
};

export const USER_TYPE = {
    local_user: 0,
    azure_ad_user: 1,
}

export const ARCHIVED_ACCESS_ROLES = [3, 5];

export const MISSION_PHASES = {
    pre_mission: 340,
    preparatory_phases: 341,
    implementation_phase: 342,
    post_mission_phase: 343,
    report_phase: 344
};